import { IQueryProductsRequest } from "@faire/web-api/indigofair/data/IQueryProductsRequest";
import { ISearchRequestReferrer } from "@faire/web-api/indigofair/data/ISearchRequestReferrer";

import { MAX_PRIMARY_RESULTS } from "./const";
import { useExplorePageSearchTerm } from "./useExplorePageSearchTerm";

export const useExplorePageProductsRequest = () => {
  const { productSearchString } = useExplorePageSearchTerm();
  return IQueryProductsRequest.build({
    query: productSearchString,
    page_number: 0,
    page_size: MAX_PRIMARY_RESULTS.desktopAndAbove,
    return_filter_sections: false,
    container_name: "explore_grid",
    allow_query_pruning: true,
    allow_related_brands_search: true,
    allow_semantically_similar_results: true,
    do_query_spell_check: true,
    initial_request_exposed_visual_filter_option_keys: [],
    referrer: ISearchRequestReferrer.build({
      referrer_type: ISearchRequestReferrer.SearchRequestReferrerType["NONE"],
    }),
  });
};
